import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]", {
    // Your custom options can be added here if needed
    on: {
        // Force byline=0
        // Attempts to set all failing despite FB object containing desired options, so replacing src on ready
        // Tried url with params, data-options, set options here based on type etc.
        'Carousel.ready': () => {
        let $fbIframe = document.querySelector('.fancybox__iframe');
        let src = $fbIframe.getAttribute('src');
        $fbIframe.setAttribute('src', src.replace('byline=1', 'byline=0'));
        },
    },
});
